import Rankings from "./Rankings.jsx";

export default Rankings;